module.exports = __webpack_public_path__ + "static/media/Darrois-Villey-Maillot-Brochier.f7136cbb.jpg";